import { Box, Image } from '@chakra-ui/react';

interface ImageSectionProps {
	url: string;
}

export const ImageSection: React.FunctionComponent<ImageSectionProps> = ({ url }) => {
	return (
		<Box as='section' p={2} pb={0}>
			<Image src={url} width='full' h='300px' maxH='300px' borderRadius='lg' objectFit='contain' />
		</Box>
	);
};
